export default __webpack_public_path__ + "static/media/warning--texts--g2.d6d56c78.png";